export enum SpillGuardPermissions {
  CanManageInvestigations = 'Can manage investigations',
  CanManageRainFall = 'Can manage rainfall',
  CanSetAlarms = 'Can set alarms',
  CanPauseAlarms = 'Can pause alarm notifications',
}

export enum SpillGuardFeatureFlags {
  NewSpills = 'New Spills',
  SnoozeAlarms = 'Snooze Alarms',
}
